/*
 *
 * MicroFrontend actions
 *
 */

import { createAction } from "redux-actions";
import { SET_MICRO_FRONTEND_ID } from "./constants";

export const setMicroFrontendId = createAction(SET_MICRO_FRONTEND_ID);
